import { CalendarCheck, Phone, ShoppingBag } from "lucide-react";
import { BOOK_URL, ORDER_URL, PHONE_TEL } from "./data";

export default function FloatingBar() {
  return (
    <div
      data-testid="mobile-floating-cta-bar"
      className="fixed bottom-0 left-0 right-0 z-50 flex items-center justify-between gap-2 border-t border-[#C97B5F]/30 bg-white/90 p-3 shadow-[0_-8px_30px_rgba(0,0,0,0.8)] backdrop-blur-xl sm:hidden"
      style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
    >
      <a
        href={ORDER_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-floating-order-online-button"
        className="flex flex-1 items-center justify-center gap-1.5 rounded-full bg-gradient-to-r from-[#E86A24] to-[#B82E1F] px-4 py-3 text-center text-xs font-semibold uppercase tracking-wider text-white shadow-lg shadow-[#E86A24]/30 transition-transform duration-150 active:scale-[0.98]"
      >
        <ShoppingBag size={14} /> Order Online
      </a>
      <a
        href={BOOK_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-floating-book-table-button"
        className="flex flex-1 items-center justify-center gap-1.5 rounded-full border border-[#C97B5F] bg-[#FAF5EC] px-4 py-3 text-center text-xs font-semibold uppercase tracking-wider text-[#8A3324] transition-transform duration-150 active:scale-[0.98]"
      >
        <CalendarCheck size={14} /> Book Table
      </a>
      <a
        href={PHONE_TEL}
        data-testid="mobile-floating-call-button"
        aria-label="Call Curry Story"
        className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-[#C97B5F]/60 bg-white text-[#8A3324] transition-transform duration-150 active:scale-95"
      >
        <Phone size={17} />
      </a>
    </div>
  );
}
